import { isEmpty } from "lodash";

export function extractEAR(text: string) {
  if (isEmpty(text)) {
    return {
      entities: [],
      relationships: [],
    };
  }

  const lines = text?.split("\n");
  const entities: string[] = [];
  const relationships: string[] = [];

  let isEntities = false;

  for (const line of lines ?? []) {
    if (line.startsWith("Entities")) {
      isEntities = true;
      continue;
    } else if (line.startsWith("Relationships")) {
      isEntities = false;
      continue;
    }

    const lineExtracted = line?.replace("-", "")?.trim();
    if (isEmpty(lineExtracted)) {
      continue;
    }

    if (isEntities) {
      entities.push(lineExtracted);
    } else {
      relationships.push(lineExtracted);
    }
  }

  return {
    entities,
    relationships,
  };
}
